import { computed } from "vue";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { CreateCallRatingInput, UpdateCallRatingInput } from "@phurshell/psiapp-frontend-core/domain";
import { ratingRepo } from "@/di/repositories";

export function useRatings() {
  const { data, isPending, refetch } = useQuery({
    queryKey: ["ratings", "list"],
    queryFn: () => ratingRepo.getCallRatings({}),
  });
  return { ratings: computed(() => data.value ?? []), isPending, refetch };
}

export function useInvalidateRatings() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["ratings"] });
}

export function useCreateRating() {
  return useMutation({
    mutationFn: (params: CreateCallRatingInput) => ratingRepo.createCallRating(params),
  });
}

export function useUpdateRating() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...params }: { id: number } & UpdateCallRatingInput) =>
      ratingRepo.updateCallRating(id, params),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["ratings"] }),
  });
}

export function useRemoveRating() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => ratingRepo.removeCallRating(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["ratings"] }),
  });
}
